import React from 'react'
import TableRow from './TableRowComponent'
import TableCell from './TableCellComponent'
import dayjs from 'dayjs'

const RoomRow = ({ room, onClick }) => (
    <TableRow available={room.available} onClick={onClick}>
        <TableCell>
            <span>{room.size}</span> <span style={{ fontSize: '.8em' }}>m³</span>
        </TableCell>
        <TableCell>
            <span>
                {room.dimensions.width} x {room.dimensions.depth} x{' '}
                {room.dimensions.height}
            </span>{' '}
        </TableCell>
        <TableCell><span style={{ fontSize: '.8em' }}>{room.place}</span></TableCell>
        <TableCell>
            {room.date ? (
                <span>{room.date}</span>
            ) : room.available ? (
                <span style={{ color: '#6aaf6a', fontSize: '.8em' }}>
                    LEDIG
                </span>
            ) : (
                <span style={{ color: '#F06F2F', fontSize: '.8em' }}>
                    fra {dayjs(room.dateAvailable).format('DD/MM/YYYY')}
                </span>
            )}
        </TableCell>
        <TableCell>
            <span>{room.price}</span> DKK
            <span style={{ fontSize: '.6em' }}>/md</span>
        </TableCell>
    </TableRow>
)

export default RoomRow



// WEBPACK FOOTER //
// ./src/components/RoomRowComponent.jsx